export const signUpForm = {
  confirmPassword: "confirmPassword",
  email: "email",
  firstName: "firstName",
  lastName: "lastName",
  telephone: "telephone",
  password: "password",
};
